/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useIntl } from "react-intl";
import { PageLink, PageTitle } from "../../components/layout/core";

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: "Barcha arizalar",
    path: "/",
    isSeparator: false,
    isActive: false,
  },
];

const Dashboard: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle
        description="Sizga tegishli fan va viloyat bo’yicha barcha arizalar"
        breadcrumbs={dashboardBreadCrumbs}
      />
      <h1>methodist</h1>
    </>
  );
};

export { Dashboard };
